/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, RemovePayload } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { roleModuleActions } from "./roleModuleSlice";
import roleModuleApi from "api/roleModuleApi";
import { RoleModuleForm } from "models/roleModule";

function* getModulesList(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      roleModuleApi.getModuleList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(roleModuleActions.getModulesSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    yield put(roleModuleActions.getModulesFailed(errorData));
  }
}

function* getAllModulesList(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      roleModuleApi.getAllModuleList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(roleModuleActions.getAllModuleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    yield put(roleModuleActions.getAllModuleListFailed(errorData));
  }
}

function* addRoleModule(action: PayloadAction<RoleModuleForm>) {
  try {
    const response: ApiResponse = yield call(
      roleModuleApi.addModule,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(roleModuleActions.addModulesSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(roleModuleActions.addModulesFailed(errorData));
  }
}

function* updateModule(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      roleModuleApi.updateModule,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(roleModuleActions.updateModuleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(roleModuleActions.updateModuleFailed(errorData));
  }
}

function* deleteModule(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      roleModuleApi.deleteModule,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(roleModuleActions.deleteModuleSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data ?? {
      success: false,
      message: error?.message || "Something went wrong",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(roleModuleActions.deleteModuleFailed(errorData));
  }
}

export default function* roleModuleSaga() {
  yield takeLatest(roleModuleActions.getModules.type, getModulesList);
  yield takeLatest(roleModuleActions.addModules.type, addRoleModule);
  yield takeLatest(roleModuleActions.updateModule.type, updateModule);
  yield takeLatest(roleModuleActions.deleteModule.type, deleteModule);
  yield takeLatest(roleModuleActions.getAllModuleList.type, getAllModulesList);
}
